module.exports = __webpack_public_path__ + "e9480bf1b80e696b29ca6299fd364715.MP3";